import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { Table } from 'antd';
import Offcanvas from 'react-bootstrap/Offcanvas';

const EntityTab = () => {


    const [showAdd, setShowAdd] = useState(false);
const [showEdit, setShowEdit] = useState(false);

const handleShowAdd = (e) => {
e.preventDefault();
setShowAdd(true);
};

const handleShowEdit = (e) => {
e.preventDefault();
setShowEdit(true);
};

const handleCloseAdd = () => setShowAdd(false);
const handleCloseEdit = () => setShowEdit(false);

const [showExtraEntity, setShowExtraEntity] = useState(false);
const [showMasterShipper, setShowMasterShipper] = useState(false);
const [showCustomBroker, setShowCustomBroker] = useState(false);
const [showSecondNotify, setShowSecondNotify] = useState(false);
const [showThirdNotify, setShowThirdNotify] = useState(false);
const [showTransporter, setShowTransporter] = useState(false);
const [showShipTo, setShowShipTo] = useState(false);
const [showBookingParty, setShowBookingParty] = useState(false);
const [showSeller, setShowSeller] = useState(false);
const [showImporter, setShowImporter] = useState(false);
const [showBuyer, setShowBuyer] = useState(false);
const [showCertifiter, setShowCertifiter] = useState(false);
const columns = [
    { title: "Ref No.", dataIndex: "SNo", key: "SNo" },
    { title: "Date", dataIndex: "Name", key: "Name" },
    { title: "Rate", dataIndex: "Alias", key: "Alias" },
    { title: "Brokerage (INR)", dataIndex: "NVOCC", key: "NVOCC" },
    { title: "Commission (INR)", dataIndex: "HomepageURL", key: "HomepageURL" },
    { title: "Other (INR)", dataIndex: "HomepageURL", key: "HomepageURL" },
];

const dataSource = [
    {
        key: "1",
    }
];

useEffect(() => {
if (showMasterShipper==true || showCustomBroker == true || showSecondNotify == true || showThirdNotify == true || showTransporter == true ||
showShipTo == true || showBookingParty == true || showSeller == true || showImporter == true || showBuyer == true) {
setShowExtraEntity(true);
} else {
setShowExtraEntity(false);
}
}, [showMasterShipper, showCustomBroker, showSecondNotify, showThirdNotify, showTransporter, showShipTo, showBookingParty, showSeller,
showImporter, showBuyer])

const shipperOptions = [
{ value: 1, label: "Rohit" },
{ value: 2, label: "Ravi" },
{ value: 3, label: "Sakshi" },
{ value: 4, label: "Abhishek" },
{ value: 5, label: "Shweta" },
];

return (
<>
    <form>
        <div className="card">
            <div className="card-body">
            <div className="table-responsive custom-table">
                                <Table className="table datanew dataTable no-footer" pagination={false}
                                    dataSource={dataSource} columns={columns} />
                            </div>
                            <div className="py-2">
            <div className="d-flex flex-wrap gap-2 mt-2 pb-2" style={{ borderBottom: '1px solid #d4d4d4' }}>
                <button className="btn btn-primary text-xs" type="button" onClick={handleShowAdd}>
                    New
                </button>
                <button className="btn btn-primary text-xs" type="button" onClick={handleShowEdit}>
                    Edit
                </button>
                <button className="btn btn-primary text-xs" type="button">
                    Delete
                </button>
            </div>
        </div>
            </div>
        </div>
    </form>

    <Offcanvas show={showAdd} onHide={handleCloseAdd} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Add Charge Head</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
            <div className="row">
              <div className="col-md-4">
                    <label className="form-label">Consol</label>
                    <Select className="custom-selector w-100" name="" />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Ref No.</label>
                        <input type="text" className="form-control form-control-sm" />
               </div>
                <div className="col-md-4">
                    <label className="form-label">Date</label>
                        <input type="date" className="form-control form-control-sm"/>
               </div>
                <div className="col-md-4">
                    <label className="form-label">Brokerage</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="text" className="form-control form-control-sm" />
                        <label className="form-label">%</label>
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-4">
                    <label className="form-label">Cost Center</label>
                    <Select className="custom-selector w-100" name="" />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Apportion</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="text" className="form-control form-control-sm" />
                        <input type="text" className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="col-md-4">
                    <label className="form-label">Commission</label>
                    <input type="text" className="form-control form-control-sm" />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Cost Center</label>
                    <Select className="custom-selector w-100" name="" />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Apportion</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="text" className="form-control form-control-sm" />
                        <input type="text" className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="col-md-4">
                    <label className="form-label">Other</label>
                        <input type="text" className="form-control form-control-sm" />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Cost Center</label>
                    <Select className="custom-selector w-100" name="" />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Apportion</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="text" className="form-control form-control-sm" />
                        <input type="text" className="form-control form-control-sm" />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-5">
                <button className="btn btn-primary text-xs" type="submit">
                    Submit
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Save & Close
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Save & New
                </button>
                <button className="btn btn-light text-xs" type="button" onClick={handleCloseAdd}>
                    Close
                </button>
            </div>
        </Offcanvas.Body>
    </Offcanvas>

    <Offcanvas show={showEdit} onHide={handleCloseEdit} placement="end">
        <Offcanvas.Header closeButton>
            <Offcanvas.Title>Edit Charge Head</Offcanvas.Title>
        </Offcanvas.Header>
        <Offcanvas.Body>
        <div className="row">
              <div className="col-md-4">
                    <label className="form-label">Consol</label>
                    <Select className="custom-selector w-100" name="" />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Ref No.</label>
                        <input type="text" className="form-control form-control-sm" />
               </div>
                <div className="col-md-4">
                    <label className="form-label">Date</label>
                        <input type="date" className="form-control form-control-sm"/>
               </div>
                <div className="col-md-4">
                    <label className="form-label">Brokerage</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="text" className="form-control form-control-sm" />
                        <label className="form-label">%</label>
                        <Select className="custom-selector w-100" name="" />
                    </div>
                </div>
                <div className="col-md-4">
                    <label className="form-label">Cost Center</label>
                    <Select className="custom-selector w-100" name="" />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Apportion</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="text" className="form-control form-control-sm" />
                        <input type="text" className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="col-md-4">
                    <label className="form-label">Commission</label>
                    <input type="text" className="form-control form-control-sm" />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Cost Center</label>
                    <Select className="custom-selector w-100" name="" />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Apportion</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="text" className="form-control form-control-sm" />
                        <input type="text" className="form-control form-control-sm" />
                    </div>
                </div>
                <div className="col-md-4">
                    <label className="form-label">Other</label>
                        <input type="text" className="form-control form-control-sm" />
                </div>
                <div className="col-md-4">
                    <label className="form-label">Cost Center</label>
                    <Select className="custom-selector w-100" name="" />
                </div>

                <div className="col-md-4">
                    <label className="form-label">Apportion</label>
                    <div className="d-flex gap-2 flex-row">
                        <input type="text" className="form-control form-control-sm" />
                        <input type="text" className="form-control form-control-sm" />
                    </div>
                </div>
            </div>
            <div className="d-flex justify-content-end gap-2 mt-5">
                <button className="btn btn-primary text-xs" type="submit">
                    Update
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Update & Close
                </button>
                <button className="btn btn-primary text-xs" type="submit">
                    Update & New
                </button>
                <button className="btn btn-light text-xs" type="button" onClick={handleCloseEdit}>
                    Close
                </button>
            </div>
        </Offcanvas.Body>
    </Offcanvas>
</>
)
}

export default EntityTab